




























import {
  getCurrentInstance,
  ComponentInternalInstance,
  defineComponent,
  computed,
  ref,
  watch,
} from '@vue/composition-api';
export default defineComponent({
  name: 'NoSelect',
  props: {},
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const routeName = computed(() => vm.$route.name);
    const fileTotal = computed(() => vm.$store.state.drawer.total);
    return {
      fileTotal,
      routeName,
    };
  },
});
